import React from 'react';
import styled from 'styled-components';
import {
  Text,
  Box,
  Flex,
  Wrapper,
  Button,
  GatsbyBackgroundImage,
} from '../components';

const PlanBox = styled(Box)`
  overflow: hidden;
  filter: blur(0px);
  box-shadow: rgba(25, 28, 31, 0.04) 0px -1px 0px,
    rgba(25, 28, 31, 0.04) 0px 8px 16px, rgba(25, 28, 31, 0.08) 0px 14px 32px;
`;

const PlanOverlay = styled(Flex)`
  left: 0px;
  top: 0px;
  background: transparent;
  transition: all 0.3s;

  .description,
  .button {
    opacity: 0;
    transition: all 0.3s;
  }

  :hover {
    background: rgba(0, 0, 0, 0.6);

    .description,
    .button {
      opacity: 1;
    }
  }

  @supports (backdrop-filter: none) {
    backdrop-filter: blur(0px);

    :hover {
      background: rgba(0, 0, 0, 0.16);
      backdrop-filter: blur(8px);
    }
  }
`;

const OtherPlans = ({ data }) => {
  const { plansCards } = data || {};

  return (
    <Wrapper>
      <Flex flexWrap="wrap" justifyContent="center" py={5}>
        {Array.isArray(plansCards) &&
          plansCards.map((plan, index) => (
            <Box width={['400px', '400px', '300px']} p={3} key={index}>
              <PlanBox position="relative" borderRadius="1.25rem" width="100%">
                <GatsbyBackgroundImage src={plan?.background?.sourceUrl}>
                  <Box width="100%" height={360} />
                </GatsbyBackgroundImage>
                <PlanOverlay
                  flexDirection="column"
                  justifyContent="space-between"
                  position="absolute"
                  width="100%"
                  height="100%"
                  px={24}
                  py={4}
                >
                  <Box>
                    <Text as="h3" color="white" fontWeight="bold" mb={2}>
                      {plan?.title}
                    </Text>
                    <Text color="white" mb={4}>
                      {plan?.subtitle}
                    </Text>
                    <Text color="white" className="description">
                      {plan?.description}
                    </Text>
                  </Box>
                  <Button
                    color="black"
                    bgcolor="rgba(255,255,255,1)"
                    bgcolorhover="rgba(255,255,255,.8)"
                    boxshadow="rgb(25 28 31 / 45%) 0px 3px 8px"
                    className="button"
                    to={plan?.button?.url}
                  >
                    {plan?.button?.title}
                  </Button>
                </PlanOverlay>
              </PlanBox>
            </Box>
          ))}
      </Flex>
    </Wrapper>
  );
};

export default OtherPlans;
